import { useMutation } from '@tanstack/react-query';
import saveAs from 'save-as';
import moment from 'moment';

import { useToast } from 'Store/toast';
import getExportReportOperators from 'Api/report-attendance/getExportReportOperators';

import getExportReportOperatorRequest from './model/request/getExportReportOperatorRequest';
import { exportReportText } from 'Const/report-attendance/text';
import { useLoader } from 'Store/loader';

const useGetExportReportOperators = () => {
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();

  return useMutation({
    mutationFn: async (filter) => {
      onShowLoader({ variant: 'loader-primary' });

      const params = getExportReportOperatorRequest(filter);

      const response = await getExportReportOperators(params);

      return { response, monthYear: filter.monthYear };
    },
    onSuccess: ({ response, monthYear }) => {
      const filename = `Report Attendance ${moment(monthYear).format('MM-YYYY')}.xlsx`;

      const blob = new Blob([response]);

      saveAs(blob, filename);

      onOpenToast({
        status: 'success',
        description: exportReportText.successExportText,
        duration: 3,
        alwaysShow: false,
      });
    },
    onError: (error) => {
      console.log(error);

      onOpenToast({
        status: 'error',
        description: exportReportText.failedExportText,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default useGetExportReportOperators;
